import { QRCodeSVG } from "qrcode.react";
import { Box, Typography } from "@mui/material";

const InstagramQRCode = () => {
  const qrUrl =
    "https://www.instagram.com/lionofcode.oficial?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==";

  return (
    <Box
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.97)",
        borderRadius: "18px",
        padding: "18px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.35)",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(218, 165, 32, 0.4)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        transition: "transform 0.3s ease",
        "&:hover": {
          transform: "scale(1.05)"
        }
      }}
      onClick={() => window.open(qrUrl, "_blank")}
    >
      <QRCodeSVG
        value={qrUrl}
        size={130} // tamanho do QR Code gerado
        fgColor="#1F2937" // cor escura
        bgColor="#ffffff" // fundo branco
        level="H" // melhor correção de erro
        includeMargin
      />

      <Typography
        variant="caption"
        sx={{
          color: "#8B4513",
          fontWeight: "bold",
          textAlign: "center",
          display: "block",
          mt: 1,
          fontSize: "0.75rem"
        }}
      >
        Central de Atendimento
      </Typography>
    </Box>
  );
};

export default InstagramQRCode;
